
import SplunkOtelWeb from './splunk-instrumentation'
// import 'react-app-polyfill/ie9'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import { HashRouter, Route, Switch, BrowserRouter as Router } from 'react-router-dom'
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { Storage } from './configs'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'

import {LoginScreen} from './screens'
import Full from './containers/Layout/Full'
import UserServices from './services/UserServices'
import configureStore from './store'
const { store, persistor } = configureStore()

var { EventEmitter } = require('fbemitter')
window.emitter = new EventEmitter()

// if (process.env.NODE_ENV !== "development")
//   {
    console.log = () => {};
 // }

const ADComponent = ({children}) => {

  const [loaded, setLoaded] = React.useState(false);
  const [pca, setPca] = React.useState(null);

  React.useEffect(() => {
    
    UserServices.ADConfig()
      .then(config => {

        const configuration = {
          auth: {
            "tenantId":config.data.tenantId,
              clientId: config.data.clientId,
              authority: config.data.authority,
              redirectUri: config.data.redirectUri,
          }
        };
        Storage.setPostLogoutRedirectUri(config.data.postLogoutRedirectUri)
        Storage.setShowLogin(config.data.showLogin)
        
        //console.log('configuration', configuration)

        const pca = new PublicClientApplication(configuration);
        setPca(pca)
        setLoaded(true); 
      })
      .catch(err => {
        setLoaded(true); 
      });
  }, []);

  return (loaded === true && pca ? <MsalProvider instance={pca}>
      {children}
    </MsalProvider>: <></>
  
  );
};

ReactDOM.render((
    <Provider store={store}>
      <ADComponent>
      <PersistGate loading={null} persistor={persistor}>
        <HashRouter>
          <Switch>
            <Route path="/login" name="Login Page" component={LoginScreen} />
            <Route path="/home" name="Home Login" component={LoginScreen} />
            <Route path="/" name="Home" component={Full} />
           
          </Switch>
        </HashRouter>
      </PersistGate>
      </ADComponent>
    </Provider>
  ), document.getElementById('root'));
